import React, {useEffect, useState} from 'react';
import {Controller, useFieldArray} from "react-hook-form";
import SearchSelect from "../../../components/searchSelect";
import axios from "../../../helpers/axios";
import sayError from "../../../helpers/sayError";
import Loader from "../../../components/loader";
import {Portlet, PortletHeader, PortletHeaderToolbar} from "../../../components/Portlet";
import Button from "react-bootstrap/Button";

const Counterpartiesfilds = ({data,formController}) => {
  const [counterpaties, setCounterpaties] = useState()
  const counterpartiesControl = useFieldArray({
    control: formController.control,
    name: `counterparties`,
    shouldUnregister: true,
    keyName: 'customId',
    defaultValue: data.counterparties
  });

  useEffect(() => {
    axios.post('/api/counterparty/searchInput')
      .then(({data})=>{
        setCounterpaties(data.data)
      })
    counterpartiesControl.replace(data.counterparties)
  }, []);

  const addCountr = ()=>{
    counterpartiesControl.append({id:''})
    console.log('plus')
  }
  const removeCountr = (index)=>{
    counterpartiesControl.remove(index)
  }
  return (
    <div>
      <Portlet>
        <PortletHeader title={'Контрагенты'} toolbar={<PortletHeaderToolbar>
          <Button size={'sm'} onClick={addCountr}>
            <i className="la la-plus"/>
            Добавить
          </Button>
        </PortletHeaderToolbar>}/>
      </Portlet>
      {counterpaties ? counterpartiesControl.fields.map((con, index) => {
        return <React.Fragment key={index}>
          <div className={'d-flex gap-2 align-items-center mb-3'}>
            <Controller
              control={formController.control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <SearchSelect
                  onChange={(v)=>{
                    onChange(v)
                  }}
                  defaultValue={con.id}
                  style={{minWidth:250}}
                  label={'Контрагент'}
                  array={counterpaties}/>
              )}
              name={`counterparties[${index}].id`}
            />
            <i className={'fa fa-plus pointer'} onClick={addCountr}/>
            <i className={'fa fa-trash pointer'} onClick={()=>removeCountr(index)}/>
          </div>
        </React.Fragment>
      }) : <i className="fa fa-spinner fa-spin"></i>}
    </div>
  );
};

export default Counterpartiesfilds;
